import React from "react";

// @ts-ignore
export default function TextWithNewlines({ text }) {
    const lines = text.split('\n');


    return (
        <div>
            {
                lines.map((line: string, index: number) => (
                    <React.Fragment key={index}>
                        {line}<br />
                    </React.Fragment>
                ))
            }
        </div>
    );
}
